import { Constants } from "../helper/constants";
import { loginRequest, msalInstance } from "../helper/AuthContext";
import { Utilities } from "./Utility";
import { app, authentication } from "@microsoft/teams-js";
import { logCustomError } from "../Services/TelemetryService";

export default class AuthHelper {
  /**
   * Uses the current authetication context to check if a user
   * is logged in. In this case, this is determined by the presence
   * of a cached user and cached token with length > 0.
   */
  public static IsUserLoggedIn(): boolean {
    let cachedUser = msalInstance.getAllAccounts()[0];
    let cachedToken = localStorage.getItem(Constants.AccessTokenKey);
    const result = cachedToken !== undefined && !!cachedUser && cachedToken !== null;
    Utilities.LogInfo("IsUserLoggedIn - cachedAccountPresent=" + !!cachedUser + ", cachedTokenPresent=" + !!cachedToken + ", result=" + result, "TempLog for debugging");
    return result;
  }

  /**
   * Attempts to get an access token for the user. If successful,
   * sends the user to the home page again where they will now
   * be logged in.
   */
  public static async Login(): Promise<void> {
    let accessToken: string = "";
    Utilities.LogInfo("Login - manual sign-in started, opening Teams auth popup", "TempLog for debugging");
    try {
      accessToken = await AuthHelper.getAccessToken();
      Utilities.LogInfo("Login - popup returned tokenLength=" + accessToken.length, "TempLog for debugging");
    } catch (err) {
      Utilities.LogError(String(err), "auth-helper.ts -> Login");
      Utilities.LogInfo("Login - popup failed: " + String(err), "TempLog for debugging");
    }

    if (accessToken.length > 0) {
      // window.history.pushState('data', '', window.location.href);
      Utilities.LogInfo("Login - token acquired, reloading " + window.location.href, "TempLog for debugging");
      window.location.assign(window.location.href);
    }
  }

  /**
   * Clears any existing user from the cache, then requests
   * an MSAL token.
   */
  public static StartSignIn(): void {
    Utilities.LogInfo("StartSignIn - clearing MSAL cache then loginRedirect", "TempLog for debugging");
    msalInstance["browserStorage"].clear();
    msalInstance.loginRedirect();
  }

  /**
   * Signout
   */
  public static Signout(): void {
    msalInstance["browserStorage"].clear();
    msalInstance.logoutRedirect();
  }

  public static async CheckTokenExpiry(token: any, flag: number): Promise<void> {
    if (token != null) {
      const parsejwt = JSON.parse(atob(token.split('.')[1]));
      if (parsejwt.exp * 1000 < Date.now()) {
        if (flag === 1) {
          AuthHelper.getRedirectToken();
        }
        else {
          //AuthHelper.getHumanApiToken();
        }
      }
    }
  }

  public static async AcquireTokenForResource(): Promise<string> {
    let loginType = localStorage.getItem("LoginType");
    Utilities.LogInfo(
      "loginType-" + loginType,
      "auth-helper.ts -> AcquireTokenForResource"
    );
    let accessToken = "";
    if (loginType === "Force") {
      Utilities.LogInfo("AcquireTokenForResource - Force branch, calling acquireTokenSilent", "TempLog for debugging");
      const token = await msalInstance.acquireTokenSilent({ account: msalInstance.getAllAccounts()[0], scopes: loginRequest.scopes });
      Utilities.LogInfo("AcquireTokenForResource - acquireTokenSilent returned tokenPresent=" + !!token?.accessToken, "TempLog for debugging");
      if (token.accessToken) {
        accessToken = token.accessToken;
        localStorage.setItem(Constants.AccessTokenKey, accessToken);
        Utilities.LogInfo(
          "forceToken -",
          "auth-helper.ts -> AcquireTokenForResource"
        );
        Utilities.LogInfo("AcquireTokenForResource - token cached, length=" + accessToken.length, "TempLog for debugging");
      } else {
        Utilities.LogInfo("AcquireTokenForResource - no token, falling back to loginRedirect", "TempLog for debugging");
        msalInstance.loginRedirect();
        // window.history.pushState('data', '', window.location.origin);
        window.location.assign(window.location.origin);
      }
    } else {
      Utilities.LogInfo("AcquireTokenForResource - non-Force branch, calling getSSOToken", "TempLog for debugging");
      this.getSSOToken().then((token) => {
        accessToken = token;
        Utilities.LogInfo("AcquireTokenForResource - getSSOToken resolved tokenPresent=" + !!token, "TempLog for debugging");
      });
    }
    return accessToken;
  }
  /**
   *
   * @returns
   */

  /**
   * Called from the sign-in-end page. Checks for the presence
   * of the AD token, and notifies teams of a successful log in
   * if it is there, or notifies of failure otherwise.
   */

  public static getAccountInfo = () => {
    const accounts = msalInstance.getAllAccounts();
    return accounts[0];
  }

  public static async EndSignIn(autoClose: boolean = true, requiredReoload: boolean = false, origin: string = window.location.origin) {
    Utilities.LogInfo("EndSignIn - started. autoClose=" + autoClose + ", requiredReload=" + requiredReoload + ", origin=" + origin, "TempLog for debugging");
    await msalInstance.handleRedirectPromise().then(async (authResponse) => {
      Utilities.LogInfo("EndSignIn - handleRedirectPromise resolved. authResponsePresent=" + !!authResponse, "TempLog for debugging");
      try {
        let accountObj;
        if (authResponse) {
          accountObj = authResponse.account;
        } else {
          accountObj = msalInstance.getAllAccounts()[0];
        }
        Utilities.LogInfo("EndSignIn - accountPresent=" + !!accountObj + ", username=" + (accountObj?.username ?? "n/a"), "TempLog for debugging");
        if (accountObj && authResponse) {
          //AuthHelper.getHumanApiToken();
          Utilities.LogInfo("EndSignIn - branch: account + authResponse, acquiring redirect token", "TempLog for debugging");
          let token = AuthHelper.getRedirectToken();
          if (requiredReoload) {
            // window.history.pushState('data', '', origin);
            Utilities.LogInfo("EndSignIn - reload requested, navigating to " + origin, "TempLog for debugging");
            window.location.assign(origin);
          }
          if ((window !== window.parent) && (window !== window.top)) {
          if (autoClose) authentication.notifySuccess(await token!);}
          Utilities.LogInfo("EndSignIn - notifySuccess evaluated (inIframe=" + ((window !== window.parent) && (window !== window.top)) + ")", "TempLog for debugging");
        } else if (accountObj) {
          //AuthHelper.getHumanApiToken();
          Utilities.LogInfo("EndSignIn - branch: account only, acquiring redirect token", "TempLog for debugging");
          AuthHelper.getRedirectToken();
        } else {
          Utilities.LogInfo("EndSignIn - branch: no account, triggering loginRedirect", "TempLog for debugging");
          await msalInstance.loginRedirect();
        }
      } catch (error) {
        logCustomError(error, "Error in SaveNotification");
        Utilities.LogInfo("EndSignIn - failed: " + String(error), "TempLog for debugging");
        authentication.notifyFailure();
      }
    });
  }

  public static async getRedirectToken(shouldRedirect: boolean = localStorage.getItem("Channel") === "web") {
    Utilities.LogInfo("getRedirectToken - started. shouldRedirect=" + shouldRedirect + ", channel=" + localStorage.getItem("Channel"), "TempLog for debugging");
    try {
      let token = await msalInstance.acquireTokenSilent({
        account: msalInstance.getAllAccounts()[0],
        scopes: loginRequest.scopes
      });
      localStorage.setItem(Constants.AccessTokenKey, token.accessToken);
      Utilities.LogInfo("getRedirectToken - acquireTokenSilent succeeded, tokenLength=" + (token.accessToken?.length ?? 0), "TempLog for debugging");
      if (shouldRedirect) {
        localStorage.setItem("LoginType", "Force");
        Utilities.LogInfo("getRedirectToken - redirecting to origin " + localStorage.getItem("origin"), "TempLog for debugging");
        window.location.assign(localStorage.getItem("origin")!);
      }
      return token.accessToken;
    } catch (err) {
      Utilities.LogInfo("getRedirectToken - silent acquisition failed, calling acquireTokenRedirect: " + String(err), "TempLog for debugging");
      await msalInstance.acquireTokenRedirect({ scopes: loginRequest.scopes });
    }
  }

  // public static async getHumanApiToken() {
  //   try {
  //     let humanApiToken = await msalInstance.acquireTokenSilent({
  //       account: msalInstance.getAllAccounts()[0],
  //       scopes: loginRequest.human_api_scope
  //     });
  //     localStorage.setItem(Constants.HumanApiTokenKey, humanApiToken.accessToken);
  //     return humanApiToken.accessToken;
  //   } catch (err) {
  //     await msalInstance.acquireTokenRedirect({ scopes: loginRequest.human_api_scope });
  //   }
  // }

  /**
   * Begins the login flow by opening a popup window
   * at the sign-in-start page.
   */
  private static async getAccessToken(): Promise<string> {
    localStorage.setItem("LoginType", "Force");
    return new Promise<string>((resolve, reject) => {
      authentication.authenticate({
        url: process.env.REACT_APP_SIGNIN_STARTURI!,
        width: 600,
        height: 535,
      }).then((accessToken: string | undefined) => {
        resolve(accessToken!);
        localStorage.setItem(Constants.AccessTokenKey, accessToken!);
      }).catch((err) => {
        reject(err);
        Utilities.LogError(err!, "auth-helper.ts -> getAccessToken");
      });
    })
  }


  public static async GetTeamsContext(): Promise<any> {
    let authUser: any;
    Utilities.LogInfo("GetTeamsContext - initializing Teams SDK", "TempLog for debugging");
    await app.initialize();
    await app.getContext().then((context: app.Context) => {
      authUser = {
        loginHint: context.user?.userPrincipalName,
        //sid: context.app.sessionId
      }
      Utilities.LogInfo("GetTeamsContext - context received. hostClientType=" + context.app?.host?.clientType + ", loginHint=" + authUser.loginHint, "TempLog for debugging");
    });
    return authUser;
  }

  /**
   * Fallback used when MSAL ssoSilent fails (e.g. AADSTS50058 on Teams mobile,
   * where the hidden iframe has no AAD session because 3rd-party cookies are blocked).
   * Asks the Teams host directly for an access token for this app's resource.
   * @returns the access token, or null when the host cannot provide one.
   */
  public static async TryGetTeamsSsoToken(): Promise<string | null> {
    try {
      Utilities.LogInfo("TryGetTeamsSsoToken - initializing Teams SDK and requesting host token", "TempLog for debugging");
      await app.initialize();

      // The mobile hosts hand `resources` straight to the native MSAL library, where a mismatch with
      // the registration fails as "Token is empty due to auth provider library error". Ask without
      // `resources` first so the host resolves it from the manifest's webApplicationInfo.resource.
      let token: string | undefined;
      try {
        token = await authentication.getAuthToken();
        Utilities.LogInfo("TryGetTeamsSsoToken - manifest-based request tokenPresent=" + !!token, "TempLog for debugging");
      } catch (manifestError) {
        Utilities.LogInfo("TryGetTeamsSsoToken - manifest-based request failed: " + String(manifestError), "TempLog for debugging");
        token = await authentication.getAuthToken({
          resources: [process.env.REACT_APP_RESOURCE as string],
        });
      }

      Utilities.LogInfo("TryGetTeamsSsoToken - host responded tokenPresent=" + !!token + ", tokenLength=" + (token?.length ?? 0), "TempLog for debugging");
      if (!token) return null;
      localStorage.setItem(Constants.AccessTokenKey, token);
      Utilities.LogInfo("TryGetTeamsSsoToken - host token cached in localStorage", "TempLog for debugging");
      return token;
    } catch (error) {
      Utilities.LogError(String(error), "auth-helper.ts -> TryGetTeamsSsoToken");
      Utilities.LogInfo("TryGetTeamsSsoToken - failed: " + String(error), "TempLog for debugging");
      return null;
    }
  }

  public static async getSSOToken(): Promise<string> {
    let ssoToken = "";
    Utilities.LogInfo("getSSOToken - requesting Teams auth token for resource " + process.env.REACT_APP_RESOURCE, "TempLog for debugging");
    await app.initialize();
    var authTokenRequest = {
      successCallback: function (token: string | undefined) {
        localStorage.setItem(Constants.AccessTokenKey, token!);
        ssoToken = token!;
        Utilities.LogInfo(
          "ssoToken -" + token,
          "auth-helper.ts -> getSSOToken"
        );
        Utilities.LogInfo("getSSOToken - success, tokenLength=" + (token?.length ?? 0), "TempLog for debugging");
      },
      failureCallback: function (error: string) {
        Utilities.LogError(error, "auth-helper.ts -> getSSOToken");
        Utilities.LogInfo("getSSOToken - failure: " + error, "TempLog for debugging");
      },
      resources: [process.env.REACT_APP_RESOURCE as string]
    };
    await authentication.getAuthToken(authTokenRequest);
    Utilities.LogInfo("getSSOToken - completed, tokenPresent=" + !!ssoToken, "TempLog for debugging");
    return ssoToken;
  }
}
